import { InvalidTransactionTypeError } from "../errors/index.js";
import { detectType } from "./detectType.js";
import * as EIP1559 from "./EIP1559/deserialize.js";
import * as EIP2930 from "./EIP2930/deserialize.js";
import * as EIP4844 from "./EIP4844/deserialize.js";
import * as EIP7702 from "./EIP7702/deserialize.js";
import * as Legacy from "./Legacy/deserialize.js";
import { type Any, Type } from "./types.js";

/**
 * Deserialize RLP encoded transaction.
 *
 * @see https://voltaire.tevm.sh/primitives/transaction for Transaction documentation
 * @since 0.0.0
 * @param data - RLP encoded transaction data
 * @returns Deserialized transaction
 * @throws {InvalidTransactionTypeError} If transaction type is unknown or unsupported
 * @example
 * ```javascript
 * import { deserialize } from './primitives/Transaction/deserialize.js';
 * const tx = deserialize(bytes);
 * ```
 */
export function deserialize(data: Uint8Array): Any {
	const type = detectType(data);
	switch (type) {
		case Type.Legacy:
			return Legacy.deserialize(data);
		case Type.EIP2930:
			return EIP2930.deserialize(data);
		case Type.EIP1559:
			return EIP1559.deserialize(data);
		case Type.EIP4844:
			return EIP4844.deserialize(data);
		case Type.EIP7702:
			return EIP7702.deserialize(data);
		default:
			throw new InvalidTransactionTypeError(
				`Unknown transaction type: ${type}`,
				{
					code: -32602,
					context: { type },
					docsPath: "/primitives/transaction/deserialize#error-handling",
				},
			);
	}
}
